import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import { TypeManagerDecorator } from "../../../../../main/type.map.service";
import { S25IconComponent } from "../../../../../modules/s25-icon/s25.icon.component";

/**
 * Dashboard panel collapse caret — Angular replacement for {@code s25-head-toggle} on dash panel heads.
 * Host keeps {@code s25-head-toggle} class so existing dash SCSS continues to apply.
 */
@TypeManagerDecorator("s25-ng-dash-panel-head-toggle")
@Component({
    selector: "s25-ng-dash-panel-head-toggle",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25IconComponent],
    host: {
        class: "s25-head-toggle tb-col dh-toggle",
    },
    template: `
        <div
            class="tb-body dash-toggle"
            tabindex="0"
            role="button"
            [attr.aria-label]="ariaLabel()"
            [attr.aria-expanded]="!collapsed()"
            [attr.title]="tooltipTitle()"
            (click)="onActivate($event)"
            (keydown.enter)="onActivate($event)"
            (keydown.space)="onActivate($event)"
        >
            <div class="tb-col s25-noselect v-layout s25-head-toggle-icon-col icon-holder">
                <div class="c-headToggle" [class.c-headToggle--open]="!collapsed()">
                    <s25-ng-icon type="caretDown" [ariaLabel]="false" />
                </div>
            </div>
        </div>
    `,
})
export class HomeDashPanelHeadToggleComponent {
    readonly collapsed = input.required<boolean>();
    readonly headerText = input.required<string>();
    readonly collapseTooltip = input("");
    readonly expandTooltip = input("");
    readonly activate = output<void>();

    readonly tooltipContent = computed(() =>
        this.collapsed() ? this.expandTooltip() || "Expand" : this.collapseTooltip() || "Collapse",
    );

    readonly tooltipTitle = computed(() => `${this.tooltipContent()} ${this.headerText()} Section`);

    readonly ariaLabel = computed(() => {
        const text = this.headerText();
        if (this.collapsed()) {
            return text ? `${text}, Collapsed` : "Section Collapsed";
        }
        return text ? `${text}, Expanded` : "Section Expanded";
    });

    onActivate(event: Event): void {
        event.preventDefault();
        this.activate.emit();
    }
}
